module.exports = __webpack_public_path__ + "img/3-dark.4b4cf9ea.png";